import { useEffect, useState } from "react";
import { Button, Col, Form, Row, Spinner } from "reactstrap";
import MyInput from "../../MyComp/UI/form/MyInput";
import {
  Block,
  BlockBetween,
  BlockHead,
  BlockHeadContent,
  BlockTitle,
  Icon,
  PreviewAltCard,
} from "../../components/Component";

import moment from "moment";
import { useFieldArray, useForm } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import DateComponent from "../../MyComp/UI/form/DateComponent";
import EmailInput from "../../MyComp/UI/form/EmailInput";
import ImageUpload from "../../MyComp/UI/form/ImageUpload";
import MyButton from "../../MyComp/UI/form/MyButton";
import MyCheck from "../../MyComp/UI/form/MyCheck";
import MyCreateSelect from "../../MyComp/UI/form/MyCreateSelect";
import MyDate from "../../MyComp/UI/form/MyDate";
import MySelect from "../../MyComp/UI/form/MySelect";
import MyTextArea from "../../MyComp/UI/form/MyTextArea";
import MyMobile from "../../MyComp/UI/form/MyMobile";
import { addDoctorAPI, getDoctorDetailAPI, reviewDoctorAPI, updateDoctorAPI } from "../../api/doctor";
import { BASE_URL_IMG, slotDuration } from "../../assets/constants";
import Content from "../../layout/content/Content";
import Head from "../../layout/head/Head";
import ViewImgAndPdf from "../ImageFolder/ViewImageAndPdf";
import { districtDDAPI, listQualificationDDAPI, listSpecificationDDAPI } from "../../api/dropdown";
import { act } from "react";
import MyEmail from "../../MyComp/UI/form/MyEmail";
import Required from "../../MyComp/UI/form/Required";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";
import useLogout from "../../hooks/useLogout";
const DoctorDetails = () => {
  const logout = useLogout();
  const location = useLocation();
  const [hasExperience, setHasExperience] = useState(false);
  const [totalExperienceDays, setTotalExperienceDays] = useState(0);
  const {
    register,
    handleSubmit,
    setValue,
    watch,
    trigger,
    clearErrors,
    reset,
    setError,
    getValues,
    control,
    formState: { errors },
  } = useForm({
    defaultValues: {
      experience: false,
      experiences: [],
      isLoading: false,
      agreed: false,
      medical_qualification: null,
      qualificationDD: [],
      specializationDD: [],

      profile_image: null,
      profile_img: null,

      pan_image: null,
      pan_img: null,

      cert_image: null,
      cert_img: null,

      aadhaar_f_image: null,
      aadhaar_f_img: null,

      aadhaar_b_image: null,
      aadhaar_b_img: null,

      objectionKeys: [],
      approvedKeys: [],

      degree: [
        {
          certificate: null,
          certificate_url: null,
        },
      ],
      qualifications: [
        {
          degree_name: "",
          institution_name: "",
          year_of_passing: null,
        },
      ],
      experiences: [
        {
          organization: "",
          from_date: null,
          to_date: null,
          department_id: "",
          is_current: false,
          description: "",
        },
      ],
      mode: location?.state?.mode || "Add",
      actionType: null,
    },
  });
  const { fields, append, remove } = useFieldArray({
    control,
    name: "degree",
  });
  const {
    fields: experienceFields,
    append: appendExperience,
    remove: removeExperience,
  } = useFieldArray({
    control,
    name: "experiences",
  });
  const {
    fields: qualificationFields,
    append: appendQualification,
    remove: removeQualification,
  } = useFieldArray({
    control,
    name: "qualifications",
  });
  const [imageOpen, setImageOpen] = useState(false);
  const isLoading = watch("isLoading");
  const navigate = useNavigate();
  const [mode, setMode] = useState(location?.state?.mode || "Add");

  const calculateTotalExperienceDays = () => {
    const experiences = watch("experiences") || [];
    let totalDays = 0;

    experiences.forEach((exp) => {
      if (exp?.from_date) {
        const from = moment(exp.from_date);

        const to = exp?.is_current ? moment() : exp?.to_date ? moment(exp.to_date) : null;

        if (to && to.isAfter(from)) {
          totalDays += to.diff(from, "days");
        }
      }
    });

    return totalDays;
  };

  const years = (calculateTotalExperienceDays() / 365).toFixed(1);

  const onFormSubmit = (data) => {
    console.log("okokok");

    const formData = new FormData();
    formData.append("name", watch("name") || null);
    formData.append("email", watch("email") || null);
    formData.append("mobile", watch("mobile") || null);
    formData.append("dob", moment(watch("dob")).format("YYYY-MM-DD") || null);
    formData.append("gender", watch("gender")?.value || null);
    // formData.append("college_name", watch("college_name") || null);
    // formData.append("qualification", watch("medical_qualification")?.value || null);
    formData.append("medical_council_registration_no", watch("registration") || null);
    // formData.append("year_of_complete_qualification", moment(watch("year_of_completion")).format("YYYY-MM-DD") || null);
    // formData.append("experience", watch("experience") || null);
    formData.append("description", watch("bio") || null);
    // formData.append("start_time", moment(watch("start_time")).format("hh:mm A") || null);
    // formData.append("end_time", moment(watch("end_time")).format("hh:mm A") || null);
    // formData.append("slot_duration", watch("slot_duration")?.value || null);
    // formData.append("availability", watch("show_availability")?.value || null);
    // formData.append("online_consultation_fees", watch("online_consultation_fees") || null);

    const metaImg = watch("profile_img");
    if (metaImg instanceof File) {
      formData.append("profile", metaImg);
    } else if (typeof metaImg === "string") {
      formData.append("profile", metaImg);
    }
    const panImg = watch("pan_img");
    if (panImg instanceof File) {
      formData.append("pan", panImg);
    } else if (typeof panImg === "string") {
      formData.append("pan", panImg);
    }
    const aadhaarFImg = watch("aadhaar_f_img");
    if (aadhaarFImg instanceof File) {
      formData.append("aadhaar_front", aadhaarFImg);
    } else if (typeof aadhaarFImg === "string") {
      formData.append("aadhaar_front", aadhaarFImg);
    }
    const aadhaarBImg = watch("aadhaar_b_img");
    if (aadhaarBImg instanceof File) {
      formData.append("aadhaar_back", aadhaarBImg);
    } else if (typeof aadhaarBImg === "string") {
      formData.append("aadhaar_back", aadhaarBImg);
    }
    const certImg = watch("cert_img");
    if (certImg instanceof File) {
      formData.append("cert_img", certImg);
    } else if (typeof certImg === "string") {
      formData.append("cert_img", certImg);
    }

    formData.append(
      "language",
      watch("known_language")?.map((item) => item.value),
    );

    if (watch("specialization")?.length > 0) {
      formData.append(
        "specialization",
        watch("specialization")?.map((item) => item.value),
      );
    } else {
      formData.append("specialization", watch("specialization").value);
    }

    formData.append("experience", watch("experience") ? (calculateTotalExperienceDays() / 365).toFixed(1) : 0);

    data?.degree?.forEach((item, index) => {
      formData.append(`degree[${index}].certificate`, item.certificate || "");
    });
    data?.qualifications?.forEach((item, index) => {
      formData.append(`qualifications[${index}].degree`, item?.degree_name?.label || "");
      formData.append(`qualifications[${index}].institute`, item?.university_name || "");
      formData.append(`qualifications[${index}].yearCompletion`, moment(item?.from_date).format("YYYY-MM-DD") || null);
    });

    if (mode == "Edit") {
      formData.append("doctorId", location?.state?.doctorId || "");
    }
    if (mode === "Approval") {
      const action = watch("actionType");

      const body = {
        remark: watch("remark") || "",
        rating: watch("rating") || "",
        keys: watch("objectionKeys")?.map((item) => item) || [],
        doctorId: location?.state?.doctorId || "",
        actionType: action === "approve" ? "approve" : "change request",
      };

      reviewDoctorAPI(body).then((res) => {
        if (res.data.status === true) {
          navigate("/doctors");
          toast.success(res.data.message);
        } else if (res.data.status === false) {
          toast.error(res.data.message);
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          logout();
        }
        toast.clearWaitingQueue();
      });

      return; // 🚨 IMPORTANT: stop further execution
    }

    if (watch("experience")) {
      data?.experiences?.forEach((item, index) => {
        formData.append(`experiences[${index}].organization`, item.organization || "");
        formData.append(`experiences[${index}].position`, item.department || "");
        formData.append(
          `experiences[${index}].startDate`,
          item.from_date ? moment(item.from_date).format("YYYY-MM-DD") : null,
        );
        formData.append(
          `experiences[${index}].endDate`,
          item.is_current ? null : item.to_date ? moment(item.to_date).format("YYYY-MM-DD") : null,
        );
        formData.append(`experiences[${index}].isPresent`, item.is_current ? 1 : 0);
        formData.append(`experiences[${index}].description`, item.description || "");
      });
    }

    if (mode == "Add") {
      addDoctorAPI(formData).then((res) => {
        if (res.data.status === true) {
          navigate("/doctors");
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      });
    }
    if (mode == "Edit") {
      updateDoctorAPI(formData).then((res) => {
        if (res.data.status === true) {
          navigate("/doctors");
          toast.success(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === false) {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      });
    }
  };
  function parseTimeToDate1(timeString) {
    const [hours, minutes] = timeString.split(":").map(Number);
    const date = new Date();
    date.setHours(hours);
    date.setMinutes(minutes);
    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  }
  function parseTimeToDate(timeString) {
    const date = new Date();

    // Check if timeString includes AM/PM
    if (/AM|PM/i.test(timeString)) {
      const [time, modifier] = timeString.split(/ (AM|PM)/i);
      let [hours, minutes] = time.split(":").map(Number);

      if (modifier.toUpperCase() === "PM" && hours < 12) {
        hours += 12;
      }
      if (modifier.toUpperCase() === "AM" && hours === 12) {
        hours = 0;
      }

      date.setHours(hours);
      date.setMinutes(minutes);
    } else {
      // Assume 24-hour format
      const [hours, minutes] = timeString.split(":").map(Number);
      date.setHours(hours);
      date.setMinutes(minutes);
    }

    date.setSeconds(0);
    date.setMilliseconds(0);
    return date;
  }

  useEffect(() => {
    setValue("selectedRow", location?.state?.data);
    if (watch("medical_qualification") != null) {
      const body = {
        qualificationId: watch("medical_qualification")?.value,
      };
      districtDDAPI(body);
    }
  }, [watch("medical_qualification")]);

  useEffect(() => {
    getQualification();
    getSpecialization();
    if (mode === "Edit" || mode === "Approval") {
      getDoctorDetail();
    }
  }, []);
  const getQualification = () => {
    listQualificationDDAPI({})
      .then((res) => {
        console.log("log", res.data.data);

        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("qualificationDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("qualificationDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          console.log("token expired", res.data);
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getSpecialization = (body) => {
    listSpecificationDDAPI(body)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === true) {
          toast.clearWaitingQueue();
          setValue("specializationDD", res.data.data);
          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("specializationDD", []);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
        } else if (res.data.status === "expired") {
          setValue("isLoading", false);
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const getDoctorDetail = () => {
    getDoctorDetailAPI(location?.state)
      .then((res) => {
        //const status = decrypt(res.data.status);
        if (res.data.status === "expired") {
          toast.error(res.data.message);
          toast.clearWaitingQueue();
          logout();
        } else if (res.data.status === true) {
          toast.success(res.data.message);
          toast.clearWaitingQueue();
          setValue("data", res.data.data);
          const doctorData = res.data.data;
          // Populate form fields with fetched data
          setValue("name", doctorData.name);
          setValue("medical_council_registration_no", doctorData.medical_council_registration_no);
          setValue("email", doctorData.email);
          setValue("mobile", doctorData.mobile);
          if (doctorData?.dob) {
            const dob = moment(
              doctorData.dob,
              ["DD/MM/YYYY", "YYYY-MM-DD"],
              true, // strict parsing
            );

            if (dob.isValid()) {
              setValue("dob", dob.toDate());
            }
          }

          //           const dobString = doctorData.dob; // Assuming dob is in "DD/MM/YYYY" format
          // const dobDate = moment(dobString, "DD/MM/YYYY").toDate();
          //           setValue("dob", dobDate);
          setValue("gender", doctorData.gender);
          setValue("medical_qualification", doctorData.qualification);
          setValue("specialization", doctorData.specialization);
          // setValue("experience", doctorData.experience);
          // setValue("college_name", doctorData.college_name);
          setValue("bio", doctorData.description);
          setValue("pan_number", doctorData.pan_number);
          setValue("aadhaar_number", doctorData.aadhaar_number);
          setValue("objectionKeys", doctorData.keys);
          setValue("remark", doctorData.remark);
          setValue("rating", doctorData.rating);
          // setValue("year_of_completion", new Date(doctorData.year_of_complete_qualification));
          const gen = [
            { value: "male", label: "Male" },
            { value: "female", label: "Female" },
            { value: "other", label: "Other" },
          ].find((item) => item.value == doctorData?.gender);
          setValue("gender", gen || null);
          setValue("registration", doctorData.medical_council_registration_no);
          setValue("kyc_status", doctorData.kyc_status);
          setValue("status", doctorData.status);
          const specializationL = doctorData?.specialization?.map((item) => {
            return { label: item, value: item };
          });
          setValue("specialization", specializationL || null);
          setValue("profile_image", doctorData.profile ? `${doctorData.profile}` : null);
          setValue("pan_image", doctorData.pan ? `${doctorData.pan}` : null);
          setValue("cert_image", doctorData.cert_img ? `${doctorData.cert_img}` : null);
          setValue("aadhaar_f_image", doctorData.aadhhar_front ? `${doctorData.aadhhar_front}` : null);
          setValue("aadhaar_b_image", doctorData.aadhhar_back ? `${doctorData.aadhhar_back}` : null);
          if (doctorData?.language) {
            const tagArray = doctorData?.language?.map((tag) => {
              const trimmed = tag.trim();
              return {
                label: trimmed,
                value: trimmed,
              };
            });

            setValue("known_language", tagArray);
          }

          // const sTime24 = doctorData?.availability[0]?.startTime; // e.g., "17:30"
          // const parsedTime = sTime24 ? parseTimeToDate(sTime24) : null;
          // const eTime24 = doctorData?.availability[0]?.endTime; // e.g., "17:30"
          // const parsedETime = eTime24 ? parseTimeToDate(eTime24) : null;
          // setValue("start_time", doctorData?.availability[0]?.startTime ? new Date(parsedTime) : null);
          // setValue("end_time", doctorData?.availability[0]?.endTime ? new Date(parsedETime) : null);
          // const slot = slotDuration.find((item) => item.value == doctorData?.availability[0]?.slot_duration);
          // setValue("slot_duration", slot || null);
          // const avail = [
          //   { value: "monthly", label: "Monthly" },
          //   { value: "weekdays", label: "Weekdays" },
          //   { value: "weekends", label: "Weekends" },
          // ].find((item) => item.value == doctorData?.availability[0]?.availability);
          // setValue("show_availability", avail || null);
          // setValue("online_consultation_fees", doctorData?.availability[0]?.fee || null);
          if (doctorData.documents && Array.isArray(doctorData.documents)) {
            // Clear existing fields
            remove();
            doctorData.documents.forEach((item) => {
              append({
                certificate: item.url ? `${item.url}` : null,
                certificate_url: item.url ? `${item.url}` : null,
              });
            });
          }
          console.log("doctor data", doctorData);

          if (doctorData?.qualifications && Array.isArray(doctorData?.qualifications)) {
            removeQualification();
            doctorData?.qualifications?.forEach((item) => {
              const degreeOption = watch("qualificationDD").find((deg) => deg.label == item.degree);
              appendQualification({
                degree_name: degreeOption || null,
                university_name: item.institute || "",
                from_date: item?.yearCompletion ? moment(item.yearCompletion, "YYYY-MM-DD").toDate() : null,
              });
            });
          }
          console.log("experiences", doctorData?.experience);

          if (doctorData?.experience && Array.isArray(doctorData?.experience)) {
            removeExperience();
            doctorData?.experience?.forEach((item) => {
              appendExperience({
                organization: item?.organization || "",
                from_date: item.startDate ? moment(item?.startDate, "YYYY-MM-DD").toDate() : null,
                to_date: item?.isPresent
                  ? moment(new Date(), "YYYY-MM-DD").toDate()
                  : item?.endDate && item?.endDate !== "null"
                    ? moment(item?.endDate, "YYYY-MM-DD").toDate()
                    : null,
                department: item?.position || "",
                is_current: item?.isPresent || false,
                description: item?.description || "",
              });
            });

            setValue("has_experience", true);
          }

          setValue("isLoading", false);
        } else if (res.data.status === false) {
          setValue("isLoading", false);
          setValue("data", []);
          toast.error(!res.data.message);
          toast.clearWaitingQueue();
        }
      })
      .catch((err) => {
        setValue("isLoading", false);
        toast.error(err?.response?.data?.message);
      });
  };
  const resetForm = () => {};
  const handleImageOpenPreview = (row) => {
    const imageUrl = `${row?.image}`;
    setValue("image_preview", imageUrl);
    setImageOpen(true);
  };
  const handleImageClose = () => {
    setImageOpen(false);
  };
  console.log("watching,", watch("experiences"));

  const formatExperience = (days) => {
    const years = Math.floor(days / 365);
    const months = Math.floor((days % 365) / 30);

    if (years > 0) {
      return `${years} year  ${months} months`;
    }
    return `${months} months`;
  };

  useEffect(() => {
    if (watch("experience") && experienceFields.length === 0) {
      appendExperience({
        organization: "",
        from_date: null,
        to_date: null,
        department_id: "",
        is_current: false,
      });
    }
  }, [watch("experience")]);

  useEffect(() => {
    if (experienceFields.length > 0) {
      setValue("experience", true);
    }
  }, [experienceFields.length]);

  const [fieldConfirmOpen, setFieldConfirmOpen] = useState(false);
  const [fieldConfirmKey, setFieldConfirmKey] = useState("");
  const [fieldConfirmLabel, setFieldConfirmLabel] = useState("");

  const openFieldConfirmModal = (fieldKey, label) => {
    setFieldConfirmKey(fieldKey);
    setFieldConfirmLabel(label);
    setFieldConfirmOpen(true);
  };

  const closeFieldConfirmModal = () => {
    setFieldConfirmOpen(false);
    setFieldConfirmKey("");
    setFieldConfirmLabel("");
  };

  const handleFieldConfirmAction = (action) => {
    const objectionKeys = watch("objectionKeys") || [];
    let updatedKeys = [...objectionKeys];

    if (action === "reject") {
      if (fieldConfirmKey && !updatedKeys.includes(fieldConfirmKey)) {
        updatedKeys.push(fieldConfirmKey);
      }
    }

    if (action === "approve") {
      updatedKeys = updatedKeys.filter((key) => key !== fieldConfirmKey);
    }

    setValue("objectionKeys", updatedKeys);
    trigger("objectionKeys");
    closeFieldConfirmModal();
  };

  const FieldWithReject = ({ fieldKey, children }) => {
    const objectionKeys = watch("objectionKeys") || [];
    const isRejected = fieldKey && objectionKeys.includes(fieldKey);

    return (
      <div className="form-group">
        <div className="d-flex align-items-end">
          <div className="flex-grow-1">{children}</div>
          {mode === "Approval" && fieldKey && (
            <Button
              type="button"
              size="sm"
              color={isRejected ? "danger" : "warning"}
              outline
              className="ms-2 mb-1"
              onClick={() => openFieldConfirmModal(fieldKey, fieldKey)}
            >
              {isRejected ? "Rejected" : "Reject"}
            </Button>
          )}
        </div>
      </div>
    );
  };

  return (
    <>
      <Head title="Doctor Registration" />
      <Content>
        <BlockHead size={`sm`}>
          <BlockBetween>
            <BlockHeadContent>
              <BlockTitle page tag="h3">
                {"Doctor Registration"}
              </BlockTitle>
            </BlockHeadContent>
            <BlockHeadContent>
              <div className="">
                <Button
                  color="primary"
                  outline
                  className={`  me-n1`}
                  onClick={() => {
                    navigate("/doctors");
                  }}
                >
                  <Icon name={"arrow-left"} />
                </Button>
              </div>
            </BlockHeadContent>
          </BlockBetween>
        </BlockHead>
        <Block>
          <PreviewAltCard>
            {/* <div className="d-flex justify-content-between align-items-center mt-5">
              <div className="mb-3">
                <h5 className="mt-5">Doctor’s Profile</h5>
                <div style={{ fontSize: "14px", color: "#666" }}>create profile to get started</div>
              </div>
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                  borderRadius: "50%",
                }}
              >
                <div style={{ fontSize: "14px", color: "#666" }}>Upload Profile Picture</div>
              </div>
            </div> */}

            <Form onSubmit={handleSubmit(onFormSubmit)}>
              <Row className=" ">
                <div className="d-flex gap-5 py-3 mb-3">
                  {" "}
                  <h5>{"Basic Details"}</h5>
                </div>
                <Col md="3">
                {/* <FieldWithReject fieldKey="name"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Your Name"
                    name="name"
                    placeholder="Enter Your Name"
                    required
                    disabled={mode == "Approval"}
                  />
                  {/* </FieldWithReject> */}
                </Col>
                <Col md="3">
                {/* <FieldWithReject fieldKey="email"> */}
                  <MyEmail
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Email Address"
                    name="email"
                    placeholder="Enter Email Address"
                    // required
                    disabled={mode == "Approval"}
                  />
                  {/* </FieldWithReject> */}
                </Col>
                <Col md="2" className={``}>
                {/* <FieldWithReject fieldKey="mobile"> */}
                                    <MyMobile
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Mobile"}
                    name={"mobile"}
                    placeholder={"Enter mobile"}
                    required
                    disabled={mode == "Approval"}
                  />
                  {/* </FieldWithReject> */}
                </Col>
                <Col md="2" className={``}>
                {/* <FieldWithReject fieldKey="dob"> */}
                  <MyDate
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Date of Birth"}
                    name={"dob"}
                    placeholder={"Enter date of birth"}
                    required
                    max={moment().subtract(20, "years").toDate()}
                    min={moment().subtract(90, "years").toDate()}
                    disabled={mode == "Approval"}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col md={2}>
                {/* <FieldWithReject fieldKey="gender"> */}
                  <MySelect
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Gender"}
                    name={"gender"}
                    placeholder={"Select gender"}
                    required
                    options={[
                      { value: "male", label: "Male" },
                      { value: "female", label: "Female" },
                      { value: "other", label: "Other" },
                    ]}
                    disabled={mode == "Approval"}
                  />
                  {/* </FieldWithReject> */}
                </Col>
                <Col md="3">
                {/* <FieldWithReject fieldKey="aadhaar_number"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Aadhaar No."
                    name="aadhaar_number"
                    placeholder="Enter Aadhaar No."
                    required
                    disabled={mode == "Approval"}
                  />
                  {/* </FieldWithReject> */}
                </Col>
                <Col md="3">
                {/* <FieldWithReject fieldKey="pan_number"> */}
                  <MyInput
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title="Pan Number"
                    name="pan_number"
                    placeholder="Enter your Pan  no."
                    required
                    disabled={mode == "Approval"}
                  />
                  {/* </FieldWithReject> */}
                </Col>

                <Col md="3">
                  <ImageUpload
                    getValues={getValues}
                    design={4}
                    id="profile_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"Profile Image"}
                    errors={errors}
                    register={register}
                    image={"profile_img"}
                    image_url={"profile_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    approve={mode === "Approval" ? true : false}
                    size={400}
                  />
                </Col>
                <Col md="3">
                  <ImageUpload
                    getValues={getValues}
                    design={4}
                    id="aadhaar_f_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"AADHAAR Front Image"}
                    errors={errors}
                    register={register}
                    image={"aadhaar_f_img"}
                    image_url={"aadhaar_f_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    validateDoc
                    approve={mode === "Approval" ? true : false}
                    size={2048}
                  />
                </Col>
                <Col md="3">
                  <ImageUpload
                    getValues={getValues}
                    design={4}
                    id="aadhaar_b_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"AADHAAR Back Image"}
                    errors={errors}
                    register={register}
                    image={"aadhaar_b_img"}
                    image_url={"aadhaar_b_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    validateDoc
                    approve={mode === "Approval" ? true : false}
                    size={2048}
                  />
                </Col>
                <Col md="3">
                  <ImageUpload
                    getValues={getValues}
                    design={4}
                    id="pan_image"
                    watch={watch}
                    trigger={trigger}
                    setError={setError}
                    clearErrors={clearErrors}
                    label={"PAN Image"}
                    errors={errors}
                    register={register}
                    image={"pan_img"}
                    image_url={"pan_image"}
                    setValue={setValue}
                    handleImageOpenPreview={handleImageOpenPreview}
                    required
                    validateDoc
                    approve={mode === "Approval" ? true : false}
                    size={2048}
                  />
                </Col>

                <Col md="12" className={``}>
                {/* <FieldWithReject fieldKey="bio"> */}
                  <MyTextArea
                    register={register}
                    watch={watch}
                    setValue={setValue}
                    trigger={trigger}
                    errors={errors}
                    title={"Bio/Description"}
                    name={"bio"}
                    placeholder={"Tell us something about you"}
                    // required
                    // min={25}
                    // max={500}
                    cols={2}
                    row={2}
                    disabled={mode == "Approval"}
                  />
                  {/* </FieldWithReject> */}
                </Col>
                <Row>
                  <div className="my-div mt-2 ">
                    <BlockTitle tag="h6">{"Professional Qualification"}</BlockTitle>
                    <hr />
                    <table className="table table-bordered table-scroll mt-3" id="productTable">
                      <thead>
                        <tr>
                          <th scope="col ">
                            Degree/Qualification
                            <Required />
                          </th>
                          <th scope="col ">
                            University/Institution Name
                            <Required />
                          </th>
                          <th scope="col ">
                            Year of Completion
                            <Required />
                          </th>

                          <th scope="col">
                            <Button
                              type="button"
                              color="primary"
                              outline
                              size={"xs"}
                              className={`  me-n1`}
                              id="addProduct"
                              onClick={() =>
                                appendQualification({
                                  degree_name: "",
                                  institution_name: "",
                                  year_of_passing: null,
                                })
                              }
                            >
                              <Icon name="plus"></Icon>
                            </Button>
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {qualificationFields.map((field, index) => (
                          <tr key={field.id}>
                            <td>
                              {/* <FieldWithReject fieldKey={`qualifications.${index}.degree_name`}> */}
                              <MySelect
                                register={register}
                                watch={watch}
                                setValue={setValue}
                                trigger={trigger}
                                errors={errors}
                                name={`qualifications.${index}.degree_name`}
                                placeholder={"Select degree"}
                                required
                                options={watch("qualificationDD")}
                                disabled={mode == "Approval"}
                              />
                              {/* </FieldWithReject> */}
                            </td>
                            <td>
                              {/* <FieldWithReject fieldKey={`qualifications.${index}.university_name`}> */}
                              <MyInput
                                register={register}
                                watch={watch}
                                setValue={setValue}
                                trigger={trigger}
                                errors={errors}
                                name={`qualifications.${index}.university_name`}
                                placeholder={"Enter university name"}
                                required
                                min={3}
                                max={50}
                                disabled={mode == "Approval"}
                              />
                              {/* </FieldWithReject> */}
                            </td>

                            <td>
                              {/* <FieldWithReject fieldKey={`qualifications.${index}.from_date`}> */}
                                                              <MyDate
                                register={register}
                                watch={watch}
                                setValue={setValue}
                                trigger={trigger}
                                errors={errors}
                                name={`qualifications.${index}.from_date`}
                                placeholder={"Choose year"}
                                required
                                max={moment().subtract(0, "years").toDate()}
                                min={moment().subtract(90, "years").toDate()}
                                disabled={mode == "Approval"}
                              />
                              {/* </FieldWithReject> */}
                            </td>

                            <td>
                              {index === 0 ? null : (
                                <Button
                                  type="button"
                                  color="danger"
                                  size="xs"
                                  outline
                                  onClick={() => removeQualification(index)}
                                >
                                  <Icon name="trash" />
                                </Button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                </Row>
                <h5 className="my-3">{"Professional Details"}</h5>
                <>
                  <Col md="4" className={``}>
                  {/* <FieldWithReject fieldKey="specialization"> */}
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Specialization"}
                      name={"specialization"}
                      placeholder={"Select specialization"}
                      required
                      options={watch("specializationDD")}
                      multi
                      disabled={mode == "Approval"}
                    />
                    {/* </FieldWithReject> */}
                  </Col>
                  <Col md="4" className={``}>
                  {/* <FieldWithReject fieldKey="registration"> */}
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Medical Council Registration No"}
                      name={"registration"}
                      placeholder={"Enter registration number"}
                      required
                      min={5}
                      max={15}
                      disabled={mode == "Approval"}
                    />
                    {/* </FieldWithReject> */}
                  </Col>

                  <Col md="4" className={``}>
                  {/* <FieldWithReject fieldKey="known_language"> */}
                                        <MyCreateSelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Languages Known"}
                      name={"known_language"}
                      placeholder={"specify known languages"}
                      required
                      multi
                      disabled={mode == "Approval"}
                    />
                    {/* </FieldWithReject> */}
                  </Col>

                  <Col md="3">
                    <ImageUpload
                      getValues={getValues}
                      id="cert_image"
                      watch={watch}
                      trigger={trigger}
                      setError={setError}
                      clearErrors={clearErrors}
                      label={"Medical Council Registration Certificate"}
                      errors={errors}
                      register={register}
                      image={"cert_img"}
                      image_url={"cert_image"}
                      setValue={setValue}
                      handleImageOpenPreview={handleImageOpenPreview}
                      required
                      validateDoc
                      approve={mode === "Approval" ? true : false}
                      size={2048}
                    />
                  </Col>

                  {fields.map((field, index) => (
                    <>
                      <Col md="2" key={field.id}>
                        {" "}
                        <ImageUpload
                          getValues={getValues}
                          id={`certificate_image_${index}`}
                          watch={watch}
                          trigger={trigger}
                          setError={setError}
                          clearErrors={clearErrors}
                          errors={errors}
                          register={register}
                          label={`Degree Certificate ${index + 1}`}
                          image={`degree.${index}.certificate`}
                          image_url={`degree.${index}.certificate_url`}
                          setValue={setValue}
                          handleImageOpenPreview={handleImageOpenPreview}
                          required
                          validateDoc
                          rm
                          index={index}
                          remove={remove}
                          approve={mode === "Approval" ? true : false}
                          size={2048}
                        />
                      </Col>
                    </>
                  ))}
                  {(watch("mode") === "Add" || watch("mode") === "Edit") && (
                    <Col md="2">
                      <Button
                        style={{ marginTop: "30px" }}
                        type="button"
                        color="primary"
                        className=" "
                        id="addDegree"
                        onClick={() => {
                          append({ certificate: null, certificate_url: null });
                        }}
                      >
                        {"Add Degree"}
                      </Button>{" "}
                    </Col>
                  )}

                  <Row>
                    <div className="mb-3">
                      <div className="my-div mt-4">
                        <label className="d-flex align-items-center gap-2">
                          <input
                            type="checkbox"
                            {...register("experience")}
                            onChange={(e) => {
                              setValue("experience", e.target.checked);
                              if (!e.target.checked) {
                                setValue("experiences", []);
                              }
                            }}
                          />
                          <BlockTitle tag="h6" className="mb-0">
                            {"Professional Experiences"}
                            {calculateTotalExperienceDays() > 0 && (
                              <span className="text-muted ms-2 fs-12">
                                ({formatExperience(calculateTotalExperienceDays())})
                              </span>
                            )}
                          </BlockTitle>
                        </label>
                      </div>

                      {watch("experience") && (
                        <div className="my-div mt-2">
                          <hr />

                          <table className="table table-bordered table-scroll mt-3" id="productTable">
                            <thead>
                              <tr>
                                <th scope="col ">
                                  Organization
                                  <Required />
                                </th>
                                <th scope="col ">
                                  Department
                                  <Required />
                                </th>
                                <th scope="col ">
                                  From Date
                                  <Required />
                                </th>
                                <th scope="col">
                                  To Date
                                  <Required />
                                </th>
                                <th scope="col">Description</th>
                                <th scope="col">
                                  <Button
                                    type="button"
                                    color="primary"
                                    outline
                                    size={"xs"}
                                    className={`  me-n1`}
                                    id="addProduct"
                                    onClick={() =>
                                      appendExperience({
                                        organization: "",
                                        from_date: null,
                                        to_date: null,
                                        department_id: "",
                                        is_current: false,
                                      })
                                    }
                                  >
                                    <Icon name="plus"></Icon>
                                  </Button>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              {experienceFields.map((field, index) => (
                                <tr key={field.id}>
                                  <td>
                                    {/* <FieldWithReject fieldKey={`experiences.${index}.organization`}> */}
                                    <MyInput
                                      register={register}
                                      watch={watch}
                                      setValue={setValue}
                                      trigger={trigger}
                                      errors={errors}
                                      name={`experiences.${index}.organization`}
                                      placeholder={"Enter organization name"}
                                      required
                                      min={3}
                                      max={50}
                                      disabled={mode == "Approval"}
                                    />
                                    {/* </FieldWithReject> */}
                                  </td>
                                  <td>
                                    {/* <FieldWithReject fieldKey={`experiences.${index}.department`}> */}
                                    <MyInput
                                      register={register}
                                      watch={watch}
                                      setValue={setValue}
                                      trigger={trigger}
                                      errors={errors}
                                      name={`experiences.${index}.department`}
                                      placeholder={"Enter department name"}
                                      required
                                      min={3}
                                      max={50}
                                      disabled={mode == "Approval"}
                                    />
                                    {/* </FieldWithReject> */}
                                  </td>

                                  <td>
                                    <MyDate
                                      register={register}
                                      watch={watch}
                                      setValue={setValue}
                                      trigger={trigger}
                                      errors={errors}
                                      name={`experiences.${index}.from_date`}
                                      placeholder={"Enter from date"}
                                      required
                                      max={moment().subtract(0, "years").toDate()}
                                      min={moment().subtract(90, "years").toDate()}
                                      disabled={mode == "Approval"}
                                    />
                                  </td>
                                  <td>
                                    <div className="d-flex flex-wrap">
                                      {" "}
                                      <MyCheck
                                        register={register}
                                        watch={watch}
                                        setValue={setValue}
                                        trigger={trigger}
                                        errors={errors}
                                        name={`experiences.${index}.is_current`}
                                        placeholder={"Current"}
                                        disabled={mode == "Approval"}
                                      />
                                      {!watch(`experiences.${index}.is_current`) && (
                                        <MyDate
                                          register={register}
                                          watch={watch}
                                          setValue={setValue}
                                          trigger={trigger}
                                          errors={errors}
                                          name={`experiences.${index}.to_date`}
                                          placeholder={"Enter To Date"}
                                          max={moment().toDate()}
                                          min={moment().subtract(90, "years").toDate()}
                                          disabled={mode == "Approval"}
                                          required={mode == "Approval"}
                                        />
                                      )}
                                    </div>
                                  </td>
                                  <td className="w-25">
                                    {/* <FieldWithReject fieldKey={`experiences.${index}.description`}> */}
                                    <MyTextArea
                                      register={register}
                                      watch={watch}
                                      setValue={setValue}
                                      trigger={trigger}
                                      errors={errors}
                                      name={`experiences.${index}.description`}
                                      placeholder={"Brief description of your role and responsibilities"}
                                      // min={25}
                                      max={500}
                                      cols={2}
                                      row={1}
                                      disabled={mode == "Approval"}
                                    />
                                    {/* </FieldWithReject> */}
                                  </td>

                                  <td>
                                    {index === 0 ? null : (
                                      <Button
                                        type="button"
                                        color="danger"
                                        size="xs"
                                        outline
                                        onClick={() => removeExperience(index)}
                                      >
                                        <Icon name="trash" />
                                      </Button>
                                    )}
                                  </td>
                                </tr>
                              ))}
                            </tbody>
                          </table>
                        </div>
                      )}
                    </div>
                  </Row>

                  {/* <div className="d-flex gap-5 py-3 mb-3">
                    {" "}
                    <h5>{"Slot Management & Availability"}</h5>
                  </div>
                  <Col md="1">
                    <DateComponent
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Start Time"
                      name="start_time"
                      placeholder="start time"
                      required
                       disabled={mode=="Approval"}
                    />
                  </Col>

                  <Col md="1">
                    <DateComponent
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="End Time"
                      name="end_time"
                      placeholder="end time"
                      required
                       disabled={mode=="Approval"}
                    />
                  </Col>
                  <Col md="3" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Slot Duration"}
                      name={"slot_duration"}
                      placeholder={"Select slot duration"}
                      required
                      options={slotDuration}
                       disabled={mode=="Approval"}
                    />
                  </Col>
                  <Col md="3" className={``}>
                    <MySelect
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Show Availability"}
                      name={"show_availability"}
                      placeholder={"show Availability"}
                      required
                      options={[
                        { value: "Monthly", label: "Monthly" },
                        { value: "Weekdays", label: "Weekdays" },
                        { value: "Weekends", label: "Weekends" },
                      ]}
                       disabled={mode=="Approval"}
                    />
                  </Col>

                  <Col md="4">
                    <MyInput
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title="Online consultation fees"
                      name="online_consultation_fees"
                      placeholder="Enter consultation fee"
                      required
                       disabled={mode=="Approval"}
                    />
                  </Col> */}
                </>
              </Row>
              {mode == "Approval" && (
                <Row>
                  <Col md={2}>
                    <div className="form-group my-2">
                      <label className="form-label fw-semibold">Rating</label>

                      <input
                        type="number"
                        min="0"
                        max="5"
                        step="0.1"
                        placeholder="0.0 – 5.0"
                        {...register("rating", {
                          required: "Rating is required",
                          min: { value: 0, message: "Minimum is 0" },
                          max: { value: 5, message: "Maximum is 5" },
                          valueAsNumber: true,
                        })}
                        className="form-control"
                      />

                      {errors?.rating && <small className="text-danger">{errors.rating.message}</small>}
                    </div>
                  </Col>

                  <Col md="10" className={``}>
                    <MyTextArea
                      register={register}
                      watch={watch}
                      setValue={setValue}
                      trigger={trigger}
                      errors={errors}
                      title={"Remark"}
                      name={"remark"}
                      placeholder={"Reason for approval/rejection"}
                      required
                      // min={25}
                      // max={500}
                      cols={2}
                      row={2}
                    />
                  </Col>
                </Row>
              )}
              {/* <Col md={6}>
                <MyCheck
                  register={register}
                  watch={watch}
                  setValue={setValue}
                  trigger={trigger}
                  errors={errors}
                  name={"agreed"}
                  placeholder={
                    <>
                      I have read and agree with the{" "}
                      <a href="/terms" target="_blank" rel="noopener noreferrer">
                        Terms and Conditions
                      </a>{" "}
                      and the{" "}
                      <a href="/privacy" target="_blank" rel="noopener noreferrer">
                        Privacy Policy
                      </a>
                      .
                    </>
                  }
                  required
                />
              </Col> */}
              {(mode == "Add" || mode == "Edit") && (
                <Col md="2" className={``}>
                  <div className="form-group" style={{ marginTop: "31px" }}>
                    <MyButton isLoading={isLoading} mode={mode} />
                  </div>
                </Col>
              )}
              {mode == "Approval" && (
                <>
                  <Row>
                    <div className="d-flex gap-2 pt-0">
                      <div className="form-group" style={{ marginTop: "31px" }}>
                        <Button
                          color="primary"
                          size="md"
                          type="submit"
                          onClick={() => setValue("actionType", "approve")}
                        >
                          {isLoading ? <Spinner size="sm" color="light" /> : "Approve Doctor"}
                        </Button>
                      </div>

                      <div className="form-group" style={{ marginTop: "31px" }}>
                        <Button
                          color="primary"
                          size="md"
                          type="submit"
                          onClick={() => setValue("actionType", "changeRequest")}
                        >
                          {isLoading ? <Spinner size="sm" color="light" /> : "Change Request"}
                        </Button>
                      </div>
                    </div>

                    {/* <div className="form-group mx-2" style={{ marginTop: "31px" }}>
                        <Button
                          disabled={isLoading || watch("objectionKeys")?.length <= 0} // Disable if already rejected
                          color="primary"
                          size="md"
                          type="submit"
                          onClick={() => setValue("actionType", "changeRequest")}
                        >
                          {isLoading ? <Spinner size="sm" color="light" /> : "Change Request"}
                        </Button>
                      </div> */}
                  </Row>
                </>
              )}
            </Form>
            <ViewImgAndPdf url={watch("image_preview")} imageOpen={imageOpen} handleImageClose={handleImageClose} />
          </PreviewAltCard>
        </Block>
      </Content>
           <Modal isOpen={fieldConfirmOpen} toggle={closeFieldConfirmModal}>
              <ModalHeader toggle={closeFieldConfirmModal}>Review Field</ModalHeader>
              <ModalBody>
                Do you want to approve or reject "{fieldConfirmLabel}"?
              </ModalBody>
              <ModalFooter>
                <Button color="secondary" onClick={closeFieldConfirmModal}>
                  Cancel
                </Button>
                <Button color="primary" onClick={() => handleFieldConfirmAction("approve")}> 
                  Approve
                </Button>
                <Button color="danger" onClick={() => handleFieldConfirmAction("reject")}>
                  Reject
                </Button>
              </ModalFooter>
            </Modal>
    </>
  );
};

export default DoctorDetails;
